import { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import { EditControl } from 'react-leaflet-draw';
import { MapContainer, FeatureGroup } from 'react-leaflet';
import IconButton from '../common/IconButton';
import { MdMyLocation } from "react-icons/md";
import LayersControlComponent from './LayerControlComponent';
import './Map.css';
import 'leaflet/dist/leaflet.css';


interface MiniMapProps {
    onAddressSelect: (coordinates: { lat: number; lon: number }) => void;
    position?: [number?, number?];
}

const MiniMap = (props: MiniMapProps) => {
    const featureGroupRef = useRef<L.FeatureGroup | null>(null);

    const [mapKey, setMapKey] = useState(0);
    const zoom = 14;
    const [position, setPosition] = useState<[number, number]>([47.582, 9.207]);
    const [markerPosition, setMarkerPosition] = useState<[number, number]>();

    const updateMarker = () => {
        if (!markerPosition || !markerPosition[0] || !markerPosition[1]) return;
        if (!featureGroupRef.current) return;

        featureGroupRef.current.clearLayers();
        const marker = L.marker([markerPosition[0], markerPosition[1]]);
        featureGroupRef.current.addLayer(marker);
    };

    const getCurrentLocation = async () => {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const newPosition: [number, number] = [pos.coords.latitude, pos.coords.longitude];
                setPosition(newPosition);
                setMarkerPosition(newPosition);
                setMapKey((prev) => prev + 1); 
            },
            (error) => console.error('Error fetching geolocation:', error),
            { enableHighAccuracy: true }
        );
    };

    useEffect(() => {
        const L = require("leaflet");
        delete L.Icon.Default.prototype._getIconUrl;

        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
            iconUrl: require("leaflet/dist/images/marker-icon.png"),
            shadowUrl: require("leaflet/dist/images/marker-shadow.png")
        });
    }, []);

    useEffect(() => {

        if(position.every((val, index) => val === props.position![index])){
            return;
        }
          
        if (props.position && props.position[0] && props.position[1]) {
            setPosition([props.position[0], props.position[1]]);
            setMarkerPosition([props.position[0], props.position[1]]);
            setMapKey((prev) => prev + 1);
        }
    }, [props.position]);


    useEffect(() => {
        setTimeout(updateMarker, 100);
    }, [markerPosition]);

    const handleCreated = (event: any) => {
        const { layerType, layer } = event;

        if (layerType === 'marker') {
            const marker = layer as L.Marker;

            featureGroupRef.current?.clearLayers();
            featureGroupRef.current?.addLayer(marker);

            const latlng = marker.getLatLng();
            setMarkerPosition([latlng.lat, latlng.lng]);
            props.onAddressSelect({ lat: latlng.lat, lon: latlng.lng });
        }
    };

    return (
        <div style={{ position: "relative" }}>
            <MapContainer key={mapKey} center={position} zoom={zoom} style={{ height: "50vh" }}>
                <LayersControlComponent />
                <FeatureGroup ref={featureGroupRef}>
                    <EditControl
                        position="topright"
                        draw={{
                            rectangle: false,
                            polygon: false,
                            circle: false,
                            marker: true,
                            polyline: false,
                            circlemarker: false,
                        }}
                        onCreated={handleCreated}
                        edit={{
                            edit: false,   
                        }}
                    />
                </FeatureGroup>
            </MapContainer>

            <IconButton
                icon={<MdMyLocation size={28} />}
                label={''}
                className='icon-button-container'
                onClick={() => getCurrentLocation()}
            />
        </div>
    );
}

export default MiniMap;
